import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';

const Row = ({ label, value, testid }) => (
  <div className="flex justify-between gap-4 text-sm py-1">
    <span className="text-[#5A5F6E]">{label}</span>
    <span className="font-medium text-right" data-testid={testid}>{value}</span>
  </div>
);

export const FinishBundleDialog = ({ open, onOpenChange, bundleCode, sku, pieces, busy, onConfirm }) => {
  const sources = new Set(pieces.map((p) => p.old_bundle_code)).size;
  return (
    <Dialog open={open} onOpenChange={(v) => !busy && onOpenChange(v)}>
      <DialogContent data-testid="fc-finish-dialog">
        <DialogHeader>
          <DialogTitle>Finish this bundle?</DialogTitle>
          <DialogDescription>
            The pieces will leave their old IN_WIP bundles and the new bundle will wait for SFG Put-Away.
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-lg border border-[#E5DFD0] p-3">
          <Row label="New bundle" value={<span className="font-mono">{bundleCode}</span>} testid="fc-finish-bundle" />
          <Row label="Item (SKU)" value={sku ? `${sku.sku_code} · ${sku.design_name || '-'}` : '-'} testid="fc-finish-sku" />
          <Row label="Pieces" value={pieces.length} testid="fc-finish-count" />
          <Row label="Taken from" value={`${sources} old bundle${sources === 1 ? '' : 's'}`} testid="fc-finish-sources" />
        </div>
        <DialogFooter>
          <Button variant="outline" disabled={busy} onClick={() => onOpenChange(false)} data-testid="fc-finish-cancel">Back</Button>
          <Button disabled={busy} onClick={onConfirm} className="bg-[#2D5F4F] hover:bg-[#244d40]" data-testid="fc-finish-confirm">
            {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Finish bundle
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
